import { computed, readonly, ref } from 'vue';
import { User } from '@/api/openapi';
import apis from '@/api/user';
import { useWait } from '@/composable/vue-wait';

const useUsers = (needsInitialFetch = () => true, getKey = () => '') => {
  const users = ref<User[]>([]);
  const activeUsers = computed(() => users.value.filter((user) => user.isActive && !user.isOnlyView));
  const invitingUsers = computed(() => users.value.filter((user) => user.isInviting && !user.isOnlyView));
  const archivedUsers = computed(() => users.value.filter((user) => !user.isActive && !user.isInviting && !user.isOnlyView));
  const autoCreatedUsers = computed(() => users.value.filter((user) => user.isOnlyView));
  const keyOfFetchUsers = computed(() => `getUsersWait${getKey()}`);

  const { doActionWithWait } = useWait();

  const fetchUsers = async () => {
    await doActionWithWait(keyOfFetchUsers.value, async () => {
      const res = await apis.getUsers();
      users.value = res.data.users;
    });
  };
  const findUser = (id: number) => {
    return users.value.find((user) => user.id === id);
  };
  if (needsInitialFetch()) {
    fetchUsers();
  }

  return {
    users: readonly(users),
    activeUsers,
    invitingUsers,
    archivedUsers,
    autoCreatedUsers,
    keyOfFetchUsers,
    fetchUsers,
    findUser,
  };
};

// TODO: 「composable/current-user.ts」に移行する。（以下詳細）
//       「ローカルストレージでの権限管理廃止」に伴って、上記を作成した。（https://github.com/smartcamp/bales-crm/pull/7554）
//       できればこれの移行もしたかったが、修正内容および影響範囲が大きくなりすぎるため、一旦移行は保留（別対応）とした。
//       上記より、いづれこれは削除する予定のため、ログインユーザー情報を使用したい場合は、こちらでなく上記を使ってください。
const useCurrentUser = () => {
  const currentUser = ref<User>(null);
  const fetchCurrentUser = async () => {
    const res = await apis.getCurrentUser();
    currentUser.value = res.data.currentUser;
  };
  const fetchCurrentUserPromise = fetchCurrentUser();
  const isBalesBPO = computed<boolean>(() => currentUser.value?.tenantType === 'bales_bpo');

  return {
    currentUser: readonly(currentUser),
    fetchCurrentUser,
    fetchCurrentUserPromise,
    isBalesBPO,
  };
};

export {
  useUsers,
  useCurrentUser,
};
